import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import NumberFormat from 'react-number-format';
import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

const TextFieldStyled = styled(TextField)(() => ({
  width: '100%'
}));

const withValueLimit = (inputObj: any, maxLimit: any) => {
  const { value } = inputObj;
  if (!maxLimit) return true;
  if (maxLimit && value <= maxLimit) return true;
  return false;
};

const NumberFormatCustom = forwardRef<any, any>((props, ref) => {
  const { onChange, maxLimit, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      thousandSeparator=" "
      isNumericString
      decimalScale={2}
      allowNegative={false}
      allowedDecimalSeparators={[',', '.']}
      isAllowed={(e) => withValueLimit(e, maxLimit)}
    />
  );
});

const NumberFormatCustomWithNegative = forwardRef<any, any>((props, ref) => {
  const { onChange, maxLimit, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      thousandSeparator=" "
      isNumericString
      decimalScale={2}
      allowNegative
      allowedDecimalSeparators={[',', '.']}
      isAllowed={(e) => withValueLimit(e, maxLimit)}
    />
  );
});

const TextMaskCustom = forwardRef<any, any>((props, ref) => {
  const { onChange, mask, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask={mask}
      definitions={{
        '#': /[0-9]/
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

export const MaskInput = (props: any) => {
  const {
    id = '',
    mask,
    label,
    name,
    helperText,
    error,
    type,
    align = 'left',
    size = 'normal',
    maxLimit,
    allowNegative,
    fullWidth = true,
    autoFocus = false,
    style = {},
    textFieldProps = {},
    required = false,
    disabled = false,
    ...other
  } = props;
  if (type === 'amount') {
    return (
      <TextFieldStyled
        label={label}
        {...other}
        required={required}
        error={error}
        helperText={helperText}
        name="numberformat"
        autoFocus={autoFocus}
        size={size}
        id="formatted-numberformat-input"
        disabled={disabled}
        InputLabelProps={{
          shrink: true
        }}
        InputProps={{
          // notched: true — принудительно открываем вырез в рамке (legend) под поднятый label.
          // С кастомным inputComponent (react-number-format) MUI не детектит «filled»,
          // из-за чего вырез схлопнут и label (shrink) наезжает на значение поля.
          notched: true,
          inputComponent: allowNegative ? NumberFormatCustomWithNegative : NumberFormatCustom,
          inputProps: {
            maxLimit,
            style: { textAlign: align }
          }
        }}
      />
    );
  }
  return (
    <TextField
      fullWidth={fullWidth}
      required={required}
      label={label}
      name={name}
      error={error}
      autoFocus={autoFocus}
      size={size}
      helperText={helperText}
      disabled={disabled}
      InputLabelProps={{
        shrink: true
      }}
      InputProps={{
        inputComponent: TextMaskCustom,
        inputProps: {
          id,
          mask,
          style: { ...style, textAlign: align },
          ...other
        }
      }}
      {...textFieldProps}
    />
  );
};
